import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import typography from 'src/utils/typography';
import _Icon from '../Icon';

export const ModalContent = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    margin: ${theme.sz.s8};
    gap: ${theme.sz.s6};

    @media (max-width: ${theme.sz.md}) {
      margin: ${theme.sz.s6};
      gap: ${theme.sz.s4};
    }
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    ${typography.paragraph.l};

    @media (max-width: ${theme.sz.md}) {
      ${typography.paragraph.m};
    }
  `,
);

export const BoldText = styled.div(
  ({ theme }) => css`
    ${typography.heading.desktop.xs};

    @media (max-width: ${theme.sz.md}) {
      ${typography.heading.mobile.xs};
    }
  `,
);

export const SecondaryDescription = styled(BoldText)(
  ({ theme }) => css`
    margin-top: ${theme.sz.s4};
  `,
);

export const ModalHeader = styled.div(
  ({ theme }) => css`
    ${typography.heading.desktop.m};

    @media (max-width: ${theme.sz.md}) {
      ${typography.heading.mobile.s};
    }
  `,
);

export const ProgressIndicator = styled.div(
  ({ theme }) => css`
    ${typography.paragraph.base};
    color: ${theme.co.secondary50};

    @media (max-width: ${theme.sz.md}) {
      ${typography.paragraph.m};
    }
  `,
);

export const ScenarioCard = styled.div(
  ({ theme }) => css`
    background-color: ${theme.co.neutral98};
    border-radius: ${theme.bo.mediumSmall};
    height: ${theme.sz.s32};
    width: ${theme.sz.s48};
    box-shadow: 0 ${theme.sz.s1} 0 0 ${theme.co.primary30};

    display: flex;
    justify-content: end;
    align-items: center;

    @media (max-width: ${theme.sz.md}) {
      height: ${theme.sz.s24};
      width: ${theme.sz.s32};
      border-radius: ${theme.bo.small};
      box-shadow: 0 ${theme.sz.s05} 0 0 ${theme.co.primary30};
    }
  `,
);

export const ScenarioImage = styled.img(
  ({ theme }) => css`
    height: ${theme.sz.s26};
    width: auto;

    @media (max-width: ${theme.sz.md}) {
      height: ${theme.sz.s18};
    }
  `,
);

export const ModalIconBar = styled.div(
  ({ theme }) => css`
    width: 100%;
    background-color: ${theme.co.neutral99};
    border-radius: 0 ${theme.sz.s6} 0 0;
    box-shadow: 0 ${theme.sz.s05} ${theme.sz.s1} 0 ${transparentize(0.75, theme.co.neutral0)};
    display: flex;
    gap: ${theme.sz.s3};
    justify-content: end;
    padding: ${theme.sz.s3} ${theme.sz.s6};

    svg {
      height: ${theme.sz.s8};
      width: ${theme.sz.s8};
    }
  `,
);

export const ModalIcon = styled(_Icon)<{ $active?: boolean }>(
  ({ theme, $active }) => css`
    border-radius: ${theme.bo.round};
    padding: ${theme.sz.s2};

    &:last-child {
      background-color: ${theme.co.primary99};
    }

    ${$active &&
    css`
      background-color: ${theme.co.primary20};
      outline: ${theme.bo.mediumWidth} solid ${theme.co.primary20};
      outline-offset: ${theme.bo.thickWidth};
    `}
  `,
);

export const ProfileIcon = styled(ModalIcon)(
  ({ theme }) => css`
    svg {
      height: ${theme.DEPRECATED_ty.largerStill};
      width: ${theme.DEPRECATED_ty.largerStill};
    }
  `,
);

export const ActionButton = styled.div(
  () => css`
    width: 100%;
  `,
);
